import { PSCDeficiency } from "../../types/psc";

export const PSCDefectCodeBody = (item: PSCDeficiency) => {
    if (!item.defective_item_code) {
        return null;
    }
    
    return <span className="psc-defect-code">{item.defective_item_code}</span>;
}